import DayOfWeek from "@/models/Shared/DayOfWeek";

export default (dayOfWeek: DayOfWeek) => {
    let returnVal = "Undefined";
    switch (dayOfWeek) {
        case DayOfWeek.Monday: {
            returnVal = "Monday"
            break;
        }
        case DayOfWeek.Tuesday: {
            returnVal = "Tuesday"
            break;
        }
        case DayOfWeek.Wednesday: {
            returnVal = "Wednesday"
            break;
        }
        case DayOfWeek.Thursday: {
            returnVal = "Thursday"
            break;
        }
        case DayOfWeek.Friday: {
            returnVal = "Friday"
            break;
        }
        case DayOfWeek.Saturday: {
            returnVal = "Saturday"
            break;
        }
        case DayOfWeek.Sunday: {
            returnVal = "Sunday"
            break;
        }
    }
    return returnVal;
}